import Vue from 'vue'
import VueAnalytics from 'vue-analytics'

const id = process.env.VUE_APP_GA_ID

if (id) {
    Vue.use(VueAnalytics, {
        id
    })
} else {
    console.warn('A google analytics id is not set for this app')
}
